/** Даты окон приёмки: разбор и подписи. Чистые функции — их и проверяет тест.
 *
 *  ⚠️ Время площадки печатаем КАК ЕСТЬ, без `new Date`: это местное время склада, и перевод в
 *  часовой пояс браузера сдвинул бы его на часы. Дату разбираем ПО ЧАСТЯМ по той же причине:
 *  строка без зоны в разных браузерах читается то как местная, то как UTC, и день уезжает.
 */

export const WEEKDAYS = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];

export const MONTHS = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

const MONTHS_OF = [
  "января",
  "февраля",
  "марта",
  "апреля",
  "мая",
  "июня",
  "июля",
  "августа",
  "сентября",
  "октября",
  "ноября",
  "декабря",
];

/** Части суток — как в кабинете площадки: два десятка часов подряд глазами не читаются. */
export const DAY_PARTS = [
  { title: "Ночь", from: 0, to: 6 },
  { title: "Утро", from: 6, to: 12 },
  { title: "День", from: 12, to: 18 },
  { title: "Вечер", from: 18, to: 24 },
];

/** «17 сентября» из `2026-09-17`. */
export function dayLabel(day: string): string {
  return `${Number(day.slice(8, 10))} ${MONTHS_OF[Number(day.slice(5, 7)) - 1]}`;
}

/** «17 сентября, 08:00» из `2026-09-17T08:00:00`. */
export function fmtSlot(iso: string): string {
  return `${dayLabel(iso.slice(0, 10))}, ${iso.slice(11, 16)}`;
}
